import React, { useEffect } from 'react';
import { SurveyQuestion } from '../../redux/types/survey';
import SurveyQuestionsComponent from '../../components/SurveyQuestionsComponent';

type Props = {
  loadSurveyQuestions: () => void;
  updateQuestions: (questions: SurveyQuestion[]) => void;
  surveyQuestions: SurveyQuestion[];
  loading: boolean;
  updating: boolean;
  builderId: number;
};

export const SurveyPostTourQuestions: React.FC<Props> = (props) => {
  const {
    loadSurveyQuestions,
    updateQuestions,
    surveyQuestions,
    loading,
    updating,
    builderId,
  } = props;

  useEffect(() => {
    if (builderId < 0) {
      return;
    }
    loadSurveyQuestions();
  }, [builderId, loadSurveyQuestions]);

  return (
    <SurveyQuestionsComponent
      loadSurveyQuestions={loadSurveyQuestions}
      updateQuestions={updateQuestions}
      surveyQuestions={surveyQuestions}
      loading={loading}
      updating={updating}
      defaultQuestions={[]}
      variant="postTour"
    />
  );
};
export default React.memo(SurveyPostTourQuestions);
